import { Prescrizione } from './prestazione';
import { AgendaUtente } from './agenda_utente';

import { Utente } from './utente';
import { Deserializable, HmModelRest } from './abstract_model';
import { date2string } from './dateStr';
import * as moment from 'moment';
import { Distretto, AziendaSanitaria } from './anagrafica_geo';
import { Struttura } from './struttura';
import { AnnotazioneEsame } from './annotazione_esame';

import * as _ from 'lodash-es';


// https://www.gurustop.net/blog/2016/05/24/how-to-use-typescript-enum-with-angular2/
export enum GruppoSanguigno {
    Assente = 'Assente',
    A = 'A',
    B = 'B',
    AB = 'AB',
    Zero = 'Zero',
}


export enum StatoEsame {
    Assente = 'Assente',
    Positivo = 'Positivo',
    Negativo = 'Negativo',
    Immune = 'Immune',
}

export let StatoEsameSelect = [
    { id: 'Assente', value: 'Assente' },
    { id: 'Positivo', value: 'Positivo' },
    { id: 'Negativo', value: 'Negativo' },
    { id: 'Immune', value: 'Immune' },
];

export let StatoEsameRHSelect = [
    { id: 'Assente', value: 'Assente' },
    { id: 'Positivo', value: 'Positivo' },
    { id: 'Negativo', value: 'Negativo' },
];

export let GruppoSanguignoSelect = [
    { id: 'Assente', value: 'Assente' },
    { id: 'A', value: 'A' },
    { id: 'B', value: 'B' },
    { id: 'AB', value: 'AB' },
    { id: 'Zero', value: 'Zero' },
];

export let StatoChiusuraGravidanza = [
    { id: 'Altro', value: 'Altro motivo (aborto, trasferimento, altro)' },
    { id: 'FinePercorso', value: 'Completamento del percorso (dopo oltre 12 mesi dal parto)' },
    // { id: "Parto", value: "Parto" }
];

export let StatoChiusuraGravidanzaAnnullabile = [
    { id: 'Altro', value: 'Altro motivo' },
    { id: 'Annullata', value: 'Annulla la gravidanza' },
    { id: 'FinePercorso', value: 'Completamento del percorso (dopo oltre 12 mesi dal parto)' },
    // { id: "Parto", value: "Parto" }
];

export enum StatoGravidanza {
    InCorso = 'InCorso',
    Parto = 'Parto',
    FinePercorso = 'FinePercorso',
    AbortoSpontaneo = 'AbortoSpontaneo',
    AbortoTerapeutico = 'AbortoTerapeutico',
    InterruzioneVolontaria = 'InterruzioneVolontaria',
    Altro = 'Altro',
    Annullata = 'Annullata',
    Oltre42 = 'Oltre42'
    // { id: "Parto", value: "Parto" }
}


export enum StatoGravidanzaLabel {
  InCorso = 'In Gravidanza',
  Parto = 'Post Parto',
  FinePercorso = 'Chiusura percorso',
  AbortoSpontaneo = 'Aborto spontaneo',
  AbortoTerapeutico = 'Aborto terapeutico',
  InterruzioneVolontaria = 'Interruzione volontaria di gravidanza',
  Altro = 'Altro',
  Annullata = 'Annullata',
  Oltre42 = 'Oltre 42 settimane'
  // { id: "Parto", value: "Parto" }
}


export class EntryPeso extends HmModelRest {
    static readonly rest_path = 'entry_peso';

    id: number;
    utente: number | Utente;
    gravidanza: number | Gravidanza;
    data: Date;
    peso_hg: number;
    da_notificare: boolean;
}

export class Gravidanza extends HmModelRest {
    static readonly rest_path = 'gravidanze';

    id: number;
    utente: number;
    Utente: number | Utente;
    token: string;
    accettazione: boolean;
    data_last_mestruazione: Date;
    certificato_data_last_mestruazione: Date;
    delegato_consegna: string;

    get certificato_data_last_mestruazione_string(): string {
        return date2string(this.certificato_data_last_mestruazione);
    }

    data_da_ecografia: boolean;
    giorno_inizio_gravidanza: number;

    stato_gravidanza: StatoGravidanza;

    data_parto: Date;
    peso_iniziale: number;
    classe_peso: string; // enum Assente, Sottopeso, Normale, Sovrappeso, Obesa
    altezza: number;
    percorso_sperimentale: boolean;

    get in_corso(): boolean {
        return this.stato_gravidanza == StatoGravidanza.InCorso;
    }

    get aperta(): boolean {
        return this.stato_gravidanza == StatoGravidanza.InCorso || this.stato_gravidanza == StatoGravidanza.Parto;
    }


    get altezza_in_metri(): number {
        return this.altezza / 100;
    }

    get peso_in_kg(): number {
        if (this.peso_iniziale)
            return this.peso_iniziale / 10;
        else return 0;
    }

    set peso_in_kg(p: number) {
        this.peso_iniziale = p * 10;
    }

    peso: number;
    prima_gravidanza: boolean;
    gemellare: boolean;
    ginecologo_privato: boolean;
    fake_gravidanza: boolean;
    entry_peso: EntryPeso[];

    codice_libretto: string;
    distretto: number; // | Distretto;
    consultorio: number; // | Struttura;
    operatore: number | Utente;
    operatore_denominazione: string;
    azienda_sanitaria: number; // | AziendaSanitaria;

    agende_utente: AgendaUtente[];

    data_test_immunologico: Date;
    data_esame_clinico: Date;
    data_esame_ecografico: Date;
    data_chiusura: Date;

    certificato_gravidanza: boolean;
    libretto_cartaceo: boolean;

    toxotest: StatoEsame;
    rubeotest: StatoEsame;

    data_ultimo_toxotest: Date;
    data_ultimo_hcvab: Date;
    data_ultimo_rubeotest: Date;

    gruppo_sanguigno: GruppoSanguigno;
    rh: StatoEsame;
    hcvab: StatoEsame;

    diabete_pregravidico: boolean;
    diabete_gest_grav_prec: boolean;
    macrosomia_fetale_grav_prec: boolean;
    diabete_parente: boolean;
    diabete_familiare: boolean;

    glicemia_alta: boolean;

    giornoGravidanza(date: Date = new Date()): number {
        return moment(date).diff(this.data_last_mestruazione, 'days');
    }

    giornoDaParto(date: Date = new Date()): number {
        return moment(date).diff(this.data_parto, 'days');
    }

    get giorno_gravidanza(): number {
        return this.giornoGravidanza();
    }

    get settimana_gravidanza(): number {
        return Math.floor(this.giornoGravidanza() / 7);
    }

    get giorno_settimana_gravidanza(): number {
        return this.giornoGravidanza() % 7;
    }

    get durata_periodo_gravidanza(): number {
        if (this.data_parto) {
            return this.giornoDaParto();
        }
        return this.giornoGravidanza();
    }

    get durata_periodo_gravidanza_settimane(): number {
        return Math.floor(this.durata_periodo_gravidanza / 7);
    }

    get durata_periodo_gravidanza_giorni_settimana(): number {
        return Math.floor(this.durata_periodo_gravidanza % 7);
    }

    get is_parto() {
        return this.data_parto != null;
    }

    get is_preparto() {
        return this.data_parto == null;
    }


    annotazioni_esami: AnnotazioneEsame[];
}

export class GiornoGravidanza {
    giorno: number = 0;

    constructor(giorno: number) {
        this.giorno = giorno;
    }

    get settimana(): number {
        return this.giorno / 7;
    }
    set settimana(sett) {
        this.giorno = sett * 7 + (this.giorno % 7);
    }

    get giorno_settimana(): number {
        return this.giorno % 7;
    }
    set giorno_settimana(giorno_sett) {
        this.giorno = (this.giorno / 7) * 7 + giorno_sett;
    }
}

export class ProfiloUtente extends Deserializable {
    utente: Utente;
    gravidanze: Gravidanza[];
    agenda_utente: AgendaUtente[];
    entry_peso: EntryPeso[];

    deserialize(input: any) {
        super.deserialize(input);
        if (this.utente) {
            this.utente = new Utente().deserialize(this.utente);
        }

        if (this.gravidanze) {
            this.gravidanze = this.gravidanze.map(item => new Gravidanza().deserialize(item));
        }

        // if (this.agenda_utente) {
        //     this.agenda_utente = this.agenda_utente.map(item => new AgendaUtente().deserialize(item));
        // }

        if (this.entry_peso) {
            this.entry_peso = this.entry_peso.map(item => new EntryPeso().deserialize(item));
        }


        return this;
    }


    _ultima_gravidanza: Gravidanza;
    get ultima_gravidanza(): Gravidanza {
        if (!this._ultima_gravidanza && this.gravidanze && this.gravidanze.length > 0) {
            this._ultima_gravidanza = this.sorted_gravidanze[0];
        }
        return this._ultima_gravidanza;
    }

    get gravidanza_in_corso(): Gravidanza {
        return this.ultima_gravidanza && (this.ultima_gravidanza.stato_gravidanza == StatoGravidanza.InCorso || this.ultima_gravidanza.stato_gravidanza == StatoGravidanza.Parto) ?
            this.ultima_gravidanza : null;
    }

    get sorted_gravidanze(): Gravidanza[] {
        return _.sortBy(this.gravidanze, 'id').reverse();
    }

    _sorted_agende: AgendaUtente[];
    get sorted_agende(): AgendaUtente[] {
        if (!this._sorted_agende && this.agenda_utente && this.agenda_utente.length > 0) {
            this._sorted_agende = _.sortBy(this.agenda_utente, ['ordinamento_inizio', 'Schema_agenda.protocollo_ordinamento']);
        }
        return this._sorted_agende;
    }
}
